import React from 'react';

const IconSound = props => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.52786 15.25H3V7.75H5.52786C5.83835 7.75 6.14458 7.67771 6.42229 7.53885L13.5 4V19L6.42229 15.4611C6.14458 15.3223 5.83835 15.25 5.52786 15.25Z" stroke="#104227" strokeWidth="2"/>
        <path d="M17.3641 17.728C20.8788 14.2133 20.8788 8.51477 17.3641 5.00005" stroke="#104227" strokeWidth="2"/>
    </svg>
);

export default IconSound;